import React from 'react';
import { SideBar } from './../../../../sidebar';
import { updateAuction, getAuction, statuses } from '../../../../../../models/auctions';
import { getAllOrganization } from '../../../../../../models/organization';
import { getAllCategories } from '../../../../../../models/categories';
import { getGroup, getGroupsList } from '../../../../../../models/groups';
import { getAllMasks, getMask } from '../../../../../../models/masks';
import swal from 'sweetalert';
import i18n from '../../../../../../i18n';
import { Map } from '../../../../../helpers/map';
import HeaderBanner from '../../../../../common/HeaderBanner';
import '../../../../../../styles/components/create-group.scss';
import { ArrowLeft, Expand, Shrink } from 'lucide-react';
import { ImagePanelTab } from './ImagePanelTab';
import { EnquiriesTab } from './EnquiriesTab';
import { ContractsTab } from './ContractsTab';
import { TermsTab } from './TermsTab';
import { AdditionalTab } from './AdditionalTab';
import { AttributesTab, AttributeTab } from './AttributeTab';
import '../../../../../../styles/components/edit-auction-tabs.scss';


// Tab content components


const TABS = [
    { key: 'details', label: 'details' },
    { key: 'images', label: 'images' },
    { key: 'enquiry', label: 'enquiry' },
    { key: 'contracts', label: 'contracts' },
    { key: 'terms', label: 'terms_conditions' },
    { key: 'additional', label: 'additional' },
    { key: 'attributes', label: 'attributes' },

];

export class EditAuctionTab extends React.Component {
    constructor(props) {
        super(props);
        let path = window.location.pathname;
        let auctionId = path.substring(path.lastIndexOf('/') + 1, path.length);

        this.state = {
            auctionId: auctionId,
            lat: 23.588,
            lng: 58.3829,
            input: {},
            errors: {},
            categories: {},
            organizations: {},
            masks: {},
            groups: {},
            is_loading: false,
            is_loaded: false,
            hideSidebar: false,
            activeTab: this.getTabFromURL(),
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.getLocation = this.getLocation.bind(this);
        this.toggleChange = this.toggleChange.bind(this);
        this.toggleZakath = this.toggleZakath.bind(this);
        this.toggleFeatured = this.toggleFeatured.bind(this);
        this.toggleAutoApproval = this.toggleAutoApproval.bind(this);
    }

    getTabFromURL() {
        const params = new URLSearchParams(window.location.search);
        return params.get('tab') || 'details';
    }

    setActiveTab = (tabKey) => {
        this.setState({ activeTab: tabKey });
        const url = new URL(window.location);
        url.searchParams.set('tab', tabKey);
        window.history.pushState({}, '', url);
    };

    componentDidMount() {
        window.scrollTo(0, 0);
        this.loadAllCategories();
        this.loadAllOrganisation();
        this.loadAllMasks();
        this.loadAllGroups();
        this.loadAuction();

        window.addEventListener('popstate', () => {
            this.setState({ activeTab: this.getTabFromURL() });
        });
    }

    componentWillUnmount() {
        window.removeEventListener('popstate', () => { });
    }

    toggleChange = () => {
        let input = this.state.input;
        input.is_extra_time = !this.state.input.is_extra_time;
        this.setState({ input });
    };

    toggleZakath = () => {
        let input = this.state.input;
        input.is_zakath = !this.state.input.is_zakath;
        this.setState({ input });
    };

    toggleFeatured = () => {
        let input = this.state.input;
        input.is_featured = !this.state.input.is_featured;
        this.setState({ input });
    };

    toggleAutoApproval = () => {
        let input = this.state.input;
        input.auto_approval = !this.state.input.auto_approval;
        this.setState({ input });
    };

    async loadAllCategories() {
        const response = await getAllCategories();
        let categories = response.data;
        this.setState({ categories });
    }

    async loadAllOrganisation() {
        const response = await getAllOrganization();
        let organizations = response.data;
        this.setState({ organizations });
    }

    async loadAllGroups() {
        const response = await getGroupsList();
        let groups = response.data;
        this.setState({ groups });
    }

    async loadAuction() {
        let id = this.state.auctionId;
        const response = await getAuction(id);
        if (response.success) {
            let auction = response.data;
            let enquiry = auction.enquiry;
            auction.selected_mask = auction.mask;
            this.setState({ input: auction, enquiries: enquiry, is_loaded: true });
        }
    }

    async loadAllMasks() {
        const response = await getAllMasks();
        let masks = response.data;
        this.setState({ masks });
    }

    async loadMask(selected_mask) {
        if (selected_mask) {
            const response = await getMask(selected_mask);
            let result = response.data;
            let input = this.state.input;
            input['class'] = result.class;
            input['start_amount'] = result.start_amount;
            input['bid_increment'] = result.bid_increment;
            this.setState({ input });
        }
    }

    handleChange(event) {
        let input = this.state.input;
        input[event.target.name] = event.target.value;
        this.setState({ input });
        if (event.target.name === 'selected_mask') {
            //this.loadMask(event.target.value);
        }
        if (event.target.name === 'group') {
            //this.loadGroup(event.target.value);
        }
    }

    async loadGroup(selected_group) {
        const response = await getGroup(selected_group);
        let result = response.data;
        let input = this.state.input;
        input['start_date'] = result.start_date;
        input['end_date'] = result.end_date;
        input['description'] = result.description;
        input['terms'] = result.terms;
        input['terms_arabic'] = result.terms_arabic;
        input['enquiries'] = result.enquiry;
        this.setState({ input });
    }

    handleSubmit = async (event) => {
        event.preventDefault();
        try {
            let payload = this.state.input;
            payload.enquiries = this.state.enquiries;
            let id = this.state.auctionId;
            const response = await updateAuction(payload, id);
            if (response && response.data && response.data.id) {
                swal(i18n.t('success'), response.message, 'success', {
                    buttons: false,
                    timer: 2000,
                }).catch((response) => {
                    swal('Failed', response.message, 'error');
                });
            } else {
                let error_message = 'Not found!!!';
                let error_messages = response.message;
                for (const key in error_messages) {
                    if (Object.hasOwnProperty.call(error_messages, key)) {
                        let element = error_messages[key];
                        error_message += '\n' + element;
                    }
                }
                swal('Failed', error_message, 'error');
            }
        } catch (err) {
            console.log(err);
        }
    };

    getLocation(lat, lng) {
        let input = this.state.input;
        input.latitude = lat;
        input.longitude = lng;
        this.setState({ lat: lat, lng: lng, input });
    }

    renderDetailsTab() {
        let categories = this.state.categories;
        let organizations = this.state.organizations;
        let masks = this.state.masks;
        let groups = this.state.groups;
        let auction = this.state.input;
        let auctionLocation = { lat: 23.588, lng: 58.3829 };
        if (auction.latitude && auction.longitude) {
            auctionLocation = { lat: Number(auction.latitude), lng: Number(auction.longitude) };
        }
        let is_loaded = this.state.is_loaded;

        return (
            <form id="UpdateProfile" autoComplete="off" onSubmit={this.handleSubmit}>
                <div className="form-content">
                    {/* ========== LEFT COLUMN ========== */}
                    <div className="left-column">

                        {/* Category, Org, Group */}
                        <div className="form-section">
                            <h2>{i18n.t('auction_group')} & Classification</h2>
                            <div className="form-row">
                                <div className="form-field">
                                    <label>Category</label>
                                    <select name="category" value={this.state.input.category} onChange={this.handleChange}>
                                        <option value="">--Category--</option>
                                        {categories.length > 0 && categories.map((item) => (
                                            <option value={item.id} key={item.id}>{item.category_name}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-field">
                                    <label>Organization</label>
                                    <select name="organization" value={this.state.input.organization} onChange={this.handleChange}>
                                        <option value="">--Organization--</option>
                                        {organizations.length > 0 && organizations.map((item) => (
                                            <option value={item.id} key={item.id}>{item.organization_name}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-field">
                                    <label>{i18n.t('auction_group')}</label>
                                    <select name="group" value={this.state.input.group} onChange={this.handleChange}>
                                        <option value="">--{i18n.t('group')}--</option>
                                        {groups.length > 0 && groups.map((item) => (
                                            <option value={item.id} key={item.id}>{item.group_name}</option>
                                        ))}
                                    </select>
                                </div>
                                {masks.length > 0 && (
                                    <div className="form-field">
                                        <label>Mask</label>
                                        <select name="selected_mask" value={this.state.input.selected_mask} onChange={this.handleChange}>
                                            <option value="">--Mask--</option>
                                            {masks.map((item) => (
                                                <option value={item.id} key={item.id}>{item.mask_name}</option>
                                            ))}
                                        </select>
                                    </div>
                                )}
                            </div>
                            <div className="form-row">
                                <div className="form-field">
                                    <label>{i18n.t('class')}</label>
                                    <select name="class" value={this.state.input.class} onChange={this.handleChange}>
                                        <option value="">--{i18n.t('class')}--</option>
                                        <option value="D">{i18n.t('diamond')}</option>
                                        <option value="G">{i18n.t('gold')}</option>
                                    </select>
                                </div>
                                <div className="form-field">
                                    <label>{i18n.t('status')}</label>
                                    <select name="status" value={this.state.input.status} onChange={this.handleChange}>
                                        <option value="">--{i18n.t('status')}--</option>
                                        {Object.keys(statuses).map((key) => (
                                            <option value={key} key={key}>{statuses[key]}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>

                        {/* Title & Description */}
                        <div className="form-section">
                            <h2>{i18n.t('title')} & {i18n.t('description')}</h2>
                            <div className="form-row">
                                <div className="form-field">
                                    <label>{i18n.t('title')}</label>
                                    <input type="text" name="title" placeholder={i18n.t('title')}
                                        value={this.state.input.title} onChange={this.handleChange} />
                                </div>
                                <div className="form-field">
                                    <label>{i18n.t('title_ar')}</label>
                                    <input type="text" name="title_ar" placeholder={i18n.t('title_ar')}
                                        value={this.state.input.title_ar} onChange={this.handleChange} dir="rtl" />
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-field">
                                    <label>{i18n.t('description')}</label>
                                    <textarea name="description" value={this.state.input.description}
                                        onChange={this.handleChange} rows={6}></textarea>
                                </div>
                                <div className="form-field">
                                    <label>{i18n.t('description')} ({i18n.t('arabic')})</label>
                                    <textarea name="description_ar" value={this.state.input.description_ar}
                                        onChange={this.handleChange} dir="rtl" rows={6}></textarea>
                                </div>
                            </div>
                        </div>



                        {/* Dates */}
                        <div className="form-section">
                            <h2>{i18n.t('auction_details')}</h2>
                            <div className="form-row">
                                <div className="form-field">
                                    <label>{i18n.t('start_date')} {this.state.input.start_date ? '(' + this.state.input.start_date + ')' : ''}</label>
                                    <input type="datetime-local" name="start_date"
                                        value={this.state.input.start_date} onChange={this.handleChange} />
                                </div>
                                <div className="form-field">
                                    <label>{i18n.t('end_date')} {this.state.input.end_date ? '(' + this.state.input.end_date + ')' : ''}</label>
                                    <input type="datetime-local" name="end_date"
                                        value={this.state.input.end_date} onChange={this.handleChange} />
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-field">
                                    <label>{i18n.t('reg_start_date')} {this.state.input.reg_start_date ? '(' + this.state.input.reg_start_date + ')' : ''}</label>
                                    <input type="datetime-local" name="reg_start_date"
                                        value={this.state.input.reg_start_date} onChange={this.handleChange} />
                                </div>
                                <div className="form-field">
                                    <label>{i18n.t('reg_end_date')} {this.state.input.reg_end_date ? '(' + this.state.input.reg_end_date + ')' : ''}</label>
                                    <input type="datetime-local" name="reg_end_date"
                                        value={this.state.input.reg_end_date} onChange={this.handleChange} />
                                </div>
                            </div>
                        </div>

                        {/* Terms */}
                        <div className="form-section">
                            <h2>{i18n.t('terms_conditions')}</h2>
                            <div className="form-row">
                                <div className="form-field">
                                    <label>{i18n.t('terms_conditions')}</label>
                                    <textarea name="terms" value={this.state.input.terms}
                                        onChange={this.handleChange} rows={6}></textarea>
                                </div>
                                <div className="form-field">
                                    <label>{i18n.t('terms_conditions')} ({i18n.t('arabic')})</label>
                                    <textarea name="terms_arabic" value={this.state.input.terms_arabic}
                                        onChange={this.handleChange} dir="rtl" rows={6}></textarea>
                                </div>
                            </div>
                        </div>


                    </div>

                    {/* ========== RIGHT COLUMN ========== */}
                    <div className="right-column">
                        <div className="form-section">
                            <h2>Configuration</h2>

                            <div className="toggle-field">
                                <label>Is Featured</label>
                                <div className={`toggle ${this.state.input.is_featured ? 'active' : ''}`}
                                    onClick={this.toggleFeatured}>
                                    <div className="toggle-slider"></div>
                                </div>
                            </div>

                            <div className="toggle-field">
                                <label>Is Zakath</label>
                                <div className={`toggle ${this.state.input.is_zakath ? 'active' : ''}`}
                                    onClick={this.toggleZakath}>
                                    <div className="toggle-slider"></div>
                                </div>
                            </div>

                            <div className="toggle-field">
                                <label>Auto Approval</label>
                                <div className={`toggle ${this.state.input.auto_approval ? 'active' : ''}`}
                                    onClick={this.toggleAutoApproval}>
                                    <div className="toggle-slider"></div>
                                </div>
                            </div>

                            <div className="toggle-field">
                                <label>Auto Bidding</label>
                                <div className={`toggle ${this.state.input.has_auto_bidding ? 'active' : ''}`}
                                    onClick={() => {
                                        let { input } = this.state;
                                        input.has_auto_bidding = !input.has_auto_bidding;
                                        this.setState({ input });
                                    }}>
                                    <div className="toggle-slider"></div>
                                </div>
                            </div>

                            <div className="toggle-field">
                                <label>{i18n.t('extra_time')}</label>
                                <div className={`toggle ${this.state.input.is_extra_time ? 'active' : ''}`}
                                    onClick={this.toggleChange}>
                                    <div className="toggle-slider"></div>
                                </div>
                            </div>
                            {this.state.input.is_extra_time && (
                                <div className="form-field" style={{ marginTop: '12px' }}>
                                    <label>{i18n.t('extra_time')} ({i18n.t('in_minutes')})</label>
                                    <input name="extra_time" type="number" value={this.state.input.extra_time}
                                        onChange={this.handleChange} placeholder={i18n.t('in_minutes')} />
                                </div>
                            )}

                            <div className="toggle-field">
                                <label>{i18n.t('is_vat_included')}</label>
                                <div className={`toggle ${this.state.input.is_vat_included ? 'active' : ''}`}
                                    onClick={() => {
                                        let { input } = this.state;
                                        input.is_vat_included = !input.is_vat_included;
                                        this.setState({ input });
                                    }}>
                                    <div className="toggle-slider"></div>
                                </div>
                            </div>

                            <div className="toggle-field">
                                <label>{i18n.t('is_service_charge_included')}</label>
                                <div className={`toggle ${this.state.input.is_service_charge_included ? 'active' : ''}`}
                                    onClick={() => {
                                        let { input } = this.state;
                                        input.is_service_charge_included = !input.is_service_charge_included;
                                        this.setState({ input });
                                    }}>
                                    <div className="toggle-slider"></div>
                                </div>
                            </div>

                            <div className="toggle-field">
                                <label>{i18n.t('is_service_charge_vat_included')}</label>
                                <div className={`toggle ${this.state.input.is_service_charge_vat_included ? 'active' : ''}`}
                                    onClick={() => {
                                        let { input } = this.state;
                                        input.is_service_charge_vat_included = !input.is_service_charge_vat_included;
                                        this.setState({ input });
                                    }}>
                                    <div className="toggle-slider"></div>
                                </div>
                            </div>
                        </div>

                        {/* Pricing */}
                        <div className="form-section">
                            <h2>{i18n.t('financial_details')}</h2>
                            <div className="form-row">
                                <div className="form-field">
                                    <label>{i18n.t('price')}</label>
                                    <input type="text" name="start_amount" placeholder={i18n.t('price')}
                                        value={this.state.input.start_amount} onChange={this.handleChange} />
                                </div>
                                <div className="form-field">
                                    <label>{i18n.t('gurantee_amount')}</label>
                                    <input type="text" name="guarantee_amount" placeholder={i18n.t('gurantee_amount')}
                                        value={this.state.input.guarantee_amount} onChange={this.handleChange} />
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-field">
                                    <label>{i18n.t('visit_amount')}</label>
                                    <input type="text" name="visit_amount" placeholder={i18n.t('visit_amount')}
                                        value={this.state.input.visit_amount} onChange={this.handleChange} />
                                </div>
                                <div className="form-field">
                                    <label>{i18n.t('vat')}</label>
                                    <input type="text" name="vat" placeholder={i18n.t('vat')}
                                        value={this.state.input.vat} onChange={this.handleChange} />
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-field">
                                    <label>{i18n.t('incr_amount')}</label>
                                    <input type="text" name="bid_increment" placeholder={i18n.t('incr_amount')}
                                        value={this.state.input.bid_increment} onChange={this.handleChange} />
                                </div>
                                <div className="form-field">
                                    <label>{i18n.t('incr_amount')} (comma separated)</label>
                                    <input type="text" name="increment_numbers" placeholder="eg: 100,200,300"
                                        value={this.state.input.increment_numbers} onChange={this.handleChange} />
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-field">
                                    <label>{i18n.t('contract_number')}</label>
                                    <input type="text" name="contract_number" placeholder={i18n.t('contract_number')}
                                        value={this.state.input.contract_number} onChange={this.handleChange} />
                                </div>
                                <div className="form-field">
                                    <label>{i18n.t('payment_type')}</label>
                                    <select name="payment_type" value={this.state.input.payment_type} onChange={this.handleChange}>
                                        <option value="">--Select--</option>
                                        <option value="Online">{i18n.t('online')}</option>
                                        <option value="Offline">{i18n.t('offline')}</option>
                                        <option value="Both">Supports both Online & Offline</option>
                                    </select>
                                </div>
                            </div>
                            <div className="form-field form-field-margin-bottom">
                                <label>{i18n.t('Enrollment amount')}</label>
                                <input type="text" name="payment_amount" placeholder={i18n.t('Enrollment amount')}
                                    value={this.state.input.payment_amount} onChange={this.handleChange} />
                            </div>
                        </div>

                        {/* Location */}
                        <div className="form-section">
                            <h2>{i18n.t('location')}</h2>
                            <div className="form-row">
                                <div className="form-field">
                                    <label>{i18n.t('location')}</label>
                                    <input type="text" name="location" placeholder={i18n.t('location')}
                                        value={this.state.input.location} onChange={this.handleChange} />
                                </div>
                                <div className="form-field">
                                    <label>{i18n.t('location')} ({i18n.t('arabic')})</label>
                                    <input type="text" name="location_ar"
                                        placeholder={i18n.t('location') + ' (' + i18n.t('arabic') + ')'}
                                        value={this.state.input.location_ar} onChange={this.handleChange} dir="rtl" />
                                </div>
                            </div>
                            <div className="form-field form-field-margin-bottom">
                                {is_loaded && (
                                    <Map getLocation={this.getLocation} defaultLocation={auctionLocation} />
                                )}
                            </div>
                            <div className="form-row">
                                <div className="form-field">
                                    <label>Latitude</label>
                                    <input type="text" name="latitude" value={this.state.input.latitude}
                                        onChange={this.handleChange} />
                                </div>
                                <div className="form-field">
                                    <label>Longitude</label>
                                    <input type="text" name="longitude" value={this.state.input.longitude}
                                        onChange={this.handleChange} />
                                </div>
                            </div>
                        </div>


                    </div>
                </div>

                {/* Submit Footer */}
                <div className="action-buttons-l2 border-top-light">
                    <button type="button" className="button1 button1-gray" onClick={() => window.history.back()}>
                        {i18n.t('cancel')}
                    </button>
                    <button type="submit" className="button1 button1-primary">
                        Update Auction
                    </button>
                </div>
            </form>
        );
    }

    render() {
        const { activeTab, auctionId } = this.state;

        return (
            <React.Fragment>
                <HeaderBanner title={i18n.t('edit_auction') || 'Edit Auction'} subtitle={i18n.t('edit_auction') || 'Edit Auction'} />
                <section className="dashboard-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-3 col-lg-12 col-md-12">
                                {!this.state.hideSidebar && <SideBar />}
                            </div>
                            <div className={this.state.hideSidebar ? 'col-xl-12 col-lg-12 col-md-12' : 'col-xl-9 col-lg-12 col-md-12'}>
                                <div className="card">
                                    <div className="card-header">
                                        <div className="expand-dashboard">
                                            <span style={{ fontSize: '1rem', marginRight: '0.5rem', cursor: 'pointer' }}
                                                onClick={() => this.setState({ hideSidebar: !this.state.hideSidebar })}>
                                                {this.state.hideSidebar ? <Shrink strokeWidth={1} /> : <Expand strokeWidth={1} />}
                                            </span>
                                        </div>
                                        <div className="header-action">
                                            <button className="button1 button1-gradient button1-back"
                                                onClick={() => window.history.back()}>
                                                <ArrowLeft size={18} className="icon" />
                                                <span>{i18n.t('back')}</span>
                                            </button>
                                        </div>
                                    </div>

                                    {/* ===== Tab Navigation ===== */}
                                    <div className="card-body" style={{ paddingBottom: 0 }}>
                                        <div className="auction-tabs-bar">
                                            {TABS.map((tab) => (
                                                <button
                                                    key={tab.key}
                                                    type="button"
                                                    className={`auction-tab-btn ${activeTab === tab.key ? 'active' : ''}`}
                                                    onClick={() => this.setActiveTab(tab.key)}
                                                >
                                                    {i18n.t(tab.label) || tab.label}
                                                </button>
                                            ))}
                                        </div>
                                    </div>

                                    {/* ===== Tab Content ===== */}
                                    <div className="card-body">
                                        <div className="create-group-container">
                                            {activeTab === 'details' && this.renderDetailsTab()}
                                            {activeTab === 'images' && <ImagePanelTab auctionId={auctionId} />}
                                            {activeTab === 'enquiry' && <EnquiriesTab auctionId={auctionId} />}
                                            {activeTab === 'contracts' && <ContractsTab auctionId={auctionId} />}
                                            {activeTab === 'terms' && <TermsTab auctionId={auctionId} />}
                                            {activeTab === 'additional' && <AdditionalTab auctionId={auctionId} />}
                                            {activeTab === 'attributes' && <AttributesTab auctionId={auctionId} />}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </React.Fragment>
        );
    }
}